"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useWithMediaQuery;
var React = _interopRequireWildcard(require("react"));
var _mediaQuery = require("@kiwicom/orbit-components/lib/utils/mediaQuery");
var _Theme = require("../../records/Theme");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function useWithMediaQuery(_ref) {
  let {
    breakpoint,
    callback
  } = _ref;
  React.useEffect(() => {
    function widthChange(mediaQuery) {
      callback(mediaQuery.matches);
    }
    const mediaQuery = window.matchMedia((0, _mediaQuery.getBreakpointWidth)(breakpoint, _Theme.themeDefault));
    mediaQuery.addListener(widthChange);
    widthChange(mediaQuery);
    return () => {
      mediaQuery.removeListener(widthChange);
    };
  }, [breakpoint, callback]);
}